import { Dispatch, FormEvent, SetStateAction, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import Modal from "../common/Modal";
import { myAxios } from "../common/functions";
import { Post } from "./types";

import { useUiStore } from "src/components/main/uiStore";
const apiMap = {"Reply": "community/createPost.php", "Edit": "community/updatePost.php"};
export default function PostReplyForm({
    post, 
    setPost, 
    reply
}:{
    post: Post,
    setPost: Dispatch<SetStateAction<Post>>,
    reply: Post,
}){
    const setShowLoader = useUiStore(state => state.setShowLoader);
    const [searchParams, setSearchParams] = useSearchParams();
    const action = searchParams.get("action") ?? "";
    const replyTo = searchParams.get("replyTo") ?? "";
    const replyId = searchParams.get("replyId") ?? "";
    const closeIt = () => {
        searchParams.delete("action");
        searchParams.delete("replyTo");
        searchParams.delete("replyId");
        setSearchParams(searchParams, { replace: true });
    }
    const handleSubmit = async (e:FormEvent<HTMLFormElement>) => {
        const formData = new FormData(e.currentTarget);
        if(action === "Reply"){
            formData.append("parentId", post.id);
            formData.append("replyTo", replyTo);
        }
        if(action === "Edit"){
            formData.append("id", replyId);
            formData.append("parentId", post.id);
        }
        //---------------------------------------------------------------------
        setShowLoader(true);
        const res = await myAxios({ fileName: apiMap[action as keyof typeof apiMap], formData: formData });
        setShowLoader(false);
        if(!res) return;
        setPost({...post, ...res.data});
        closeIt();
    }
    const inputRef = useRef<HTMLTextAreaElement | null>(null);
    useEffect(() => {
        if(inputRef.current){
            const input = inputRef.current;
            input.focus();
            input.setSelectionRange(input.value.length, input.value.length);
        }
    }, [])
    //--------------------------------------------------------------------------------------------
    return(
        <Modal
            closeIt = {closeIt}
            title = {action}
            width = {"900px"}
            handleFormSubmit = {handleSubmit}
            actionKey = {action}
        >
            <div>
                <div className = "my-2" style = {{display:"flex"}}>
                    <span className = "fw-bold me-3">Body:</span>
                    <textarea ref = {inputRef} required className = "form-control" style = {{flexGrow: 1}} name = "body" defaultValue = {reply?.body ?? ""}/>
                </div>
            </div>
        </Modal>
    )
}